import React from "react";
import "../../Styles/Profile.css";
const SecurityAndPrivacy = () => {
  return (
    <div className="tab-pane text-light" id="securityPrivacy" role="tabpanel">
      <div className="card-header">
        <h6 className="card-title mb-0">Security &amp; Privacy</h6>
      </div>
      <div className="card-body">
        <div className="mb-4 pb-2">
          <div className="d-flex flex-column flex-sm-row mb-4 mb-sm-0">
            <div className="flex-grow-1">
              <h6 className="fs-md mb-1">Two-factor Authentication</h6>
              <p className="text-secondary">
                Two-factor authentication is an enhanced security. Once enabled,
                you'll be required to give two types of identification when you
                log into portal.
              </p>
            </div>
            <div className="flex-shrink-0 ms-sm-3">
              <a href="#" className="btn btn-sm btn-success">
                Enable Two-factor Authentication
              </a>
            </div>
          </div>
          <div className="d-flex flex-column flex-sm-row mb-4 mb-sm-0 mt-2">
            <div className="flex-grow-1">
              <h6 className="fs-md mb-1">Secondary Verification</h6>
              <p className="text-secondary">
                The first factor is a password and the second commonly includes
                a text with a code sent to your smartphone.
              </p>
            </div>
            <div className="flex-shrink-0 ms-sm-3">
              <a href="#" className="btn btn-sm btn-success">
                Set up secondary method
              </a>
            </div>
          </div>

          <div className="d-flex flex-column flex-sm-row mb-4 mb-sm-0 mt-2">
            <div className="flex-grow-1">
              <h6 className="fs-md mb-1">Backup Codes</h6>
              <p className="text-secondary mb-sm-0">
                A backup code is automatically generated for you when you turn
                on two-factor authentication through your iOS or Android Twitter
                app. You can also generate a backup code on twitter.com.
              </p>
            </div>
            <div className="flex-shrink-0 ms-sm-3">
              <a href="#" className="btn btn-sm btn-success">
                Generate backup codes
              </a>
            </div>
          </div>
        </div>
        <div className="mb-3">
          <h5 className="card-title text-decoration-underline mb-3">
            Application Notifications:
          </h5>
          <ul className="list-unstyled mb-0">
            <li className="d-flex">
              <div className="flex-grow-1">
                <label
                  htmlFor="directMessage"
                  className="form-check-label fs-md"
                >
                  Direct messages
                </label>
                <p className="text-secondary">
                  Messages from people you follow
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="directMessage"
                    defaultChecked=""
                  />
                </div>
              </div>
            </li>
            <li className="d-flex mt-2">
              <div className="flex-grow-1">
                <label
                  className="form-check-label fs-md mb-1"
                  htmlFor="desktopNotification"
                >
                  Show desktop notifications
                </label>
                <p className="text-secondary">
                  Choose the option you want as your default setting. Block a
                  site: Next to "Not allowed to send notifications," click Add.
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="desktopNotification"
                    defaultChecked=""
                  />
                </div>
              </div>
            </li>

            <li className="d-flex mt-2">
              <div className="flex-grow-1">
                <label
                  className="form-check-label fs-md mb-1"
                  htmlFor="emailNotification"
                >
                  Show email notifications
                </label>
                <p className="text-secondary">
                  Under Settings, choose Notifications. Under Select an account,
                  choose the account to enable notifications for.
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="emailNotification"
                  />
                </div>
              </div>
            </li>
            <li className="d-flex mt-2">
              <div className="flex-grow-1">
                <label
                  className="form-check-label fs-md mb-1"
                  htmlFor="chatNotification"
                >
                  Show chat notifications
                </label>
                <p className="text-secondary">
                  To prevent duplicate mobile notifications from the Gmail and
                  Chat apps, in settings, turn off Chat notifications.
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="chatNotification"
                  />
                </div>
              </div>
            </li>
            <li className="d-flex mt-2">
              <div className="flex-grow-1">
                <label
                  className="form-check-label fs-md mb-1"
                  htmlFor="purchaesNotification"
                >
                  Show purchase notifications
                </label>
                <p className="text-secondary">
                  Get real-time purchase alerts to protect yourself from
                  fraudulent charges.
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="purchaesNotification"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        {/* <div>
          <h5 className="card-title text-decoration-underline mb-3 text-danger">
            Delete This Account:
          </h5>
          <p className="text-secondary">
            Go to the Data &amp; Privacy section of your profile Account. Scroll
            to "Your data &amp; privacy options." Delete your Profile Account.
            Follow the instructions to delete your account :
          </p>
          <div>
            <input
              type="password"
              className="bg-dark text-light border-light input-placeholder-light form-control"
              id="passwordInput"
              placeholder="Enter your password"
              defaultValue="richard@321654987"
              style={{ maxWidth: 265 }}
            />
          </div>
          <div className="hstack gap-2 mt-3">
            <a href="#" className="btn btn-outline-danger">
              Close &amp; Delete This Account
            </a>
            <a href="#" className="btn btn-light">
              Cancel
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SecurityAndPrivacy;
